// MF-67 — Pick a severity from the school's scale (Minor → Critical) as a one-click row of coloured
// badges, in the scale's order. onChange(code, severity).
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ColorBadge from './ColorBadge'
import FormField from './FormField'
import { loadSeverities } from '../../../../store/actions/journalSeveritiesActions'

const SEVERITY_HELP =
  'How serious it is, on the school’s scale (Minor → Critical). Only for types graded by severity, e.g. Negative. Entries inherit it from the template.'

const SeverityChips = ({
  value,
  onChange,
  label = 'Severity',
  help = SEVERITY_HELP,
  hint,
  required,
  emptyText = 'No severities yet.'
}) => {
  const dispatch = useDispatch()
  const list = useSelector((state) => state.journalSeverities?.severities?.list || [])

  useEffect(() => {
    if (!list.length) dispatch(loadSeverities({ limit: 200 }))
    // Load once; the list is tenant-wide and rarely changes within a form session.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  const options = list
  return (
    <FormField label={label} help={help} hint={hint} required={required}>
      {!options.length ? (
        <span style={{ fontSize: 13, color: 'rgb(148, 163, 184)' }}>{emptyText}</span>
      ) : null}
      <div className='flex gap-2 flex-wrap'>
        {options.map((r) => {
          const selected = value === r.code
          return (
            <button
              key={r.code}
              type='button'
              aria-pressed={selected}
              onClick={() => onChange(r.code, r)}
              style={{ padding: 0, border: 'none', background: 'none', cursor: 'pointer', borderRadius: 999 }}
            >
              <ColorBadge label={r.label} color={r.color} variant={selected ? 'solid' : 'soft'} />
            </button>
          )
        })}
      </div>
    </FormField>
  )
}

export default SeverityChips
